import { ArrowDown } from "lucide-react";

const HeroDiagnostico = () => {
  const scrollToForm = () => {
    const formSection = document.getElementById("form-section");
    if (formSection) {
      formSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="min-h-screen flex items-center bg-[#112711] relative overflow-hidden">
      {/* Subtle texture overlay */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCI+CjxyZWN0IHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgZmlsbD0iIzExMjcxMSI+PC9yZWN0Pgo8cmVjdCB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBmaWxsPSIjMWEzYTFhIiBvcGFjaXR5PSIwLjMiPjwvcmVjdD4KPC9zdmc+')] opacity-30" />
      
      {/* Content */}
      <div className="relative z-10 section-container pt-28 pb-16">
        <div className="max-w-2xl mx-auto">
          {/* Tag */}
          <p className="text-[10px] md:text-xs uppercase tracking-[0.25em] text-[#F3DE2C] font-body font-medium mb-6">
            Consultoria Patrimonial Independente
          </p>
          
          {/* Headline */}
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-display font-normal leading-[1.2] mb-8 text-[#FAFAFA]">
            A Allu está convidando um grupo seleto de pessoas para uma conversa estratégica sobre gestão patrimonial{" "}
            <span className="text-[#F3DE2C]">— de ponta a ponta.</span>
          </h1>
          
          {/* Subheadline */}
          <p className="text-sm md:text-base text-[#FAFAFA]/85 font-body leading-relaxed mb-5">
            Como parte de sua atuação em soluções financeiras de longo prazo, a Allu está abrindo algumas conversas individuais para discutir{" "}
            <span className="underline decoration-[#FAFAFA]/50 underline-offset-4">
              organização patrimonial, investimentos, otimização de impostos e planejamento sucessório
            </span>
            {" "}—{" "}
            <span className="text-[#F3DE2C]">de forma integrada e estratégica.</span>
          </p>
          
          {/* Complementary text */}
          <p className="text-xs md:text-sm text-[#FAFAFA]/70 font-body leading-relaxed mb-10">
            A ideia é que a partir dessa conversa você{" "}
            <span className="text-[#F3DE2C] underline decoration-[#F3DE2C]/50 underline-offset-4">
              receba um diagnóstico sólido do seu contexto patrimonial atual
            </span>
            , podendo avaliar de maneira simples se ele está alinhado com seus objetivos de médio e longo prazo.{" "}
            <span className="text-[#F3DE2C]">
              Não há nenhum tipo de custo para recebimento do diagnóstico.
            </span>
          </p>
          
          {/* CTA Button */}
          <button
            onClick={scrollToForm}
            className="group inline-flex items-center gap-2 bg-[#F3DE2C] text-[#112711] px-6 py-3 rounded-full text-sm font-medium transition-all hover:bg-[#F3DE2C]/90"
          >
            Solicitar diagnóstico patrimonial
            <ArrowDown className="w-4 h-4 transition-transform group-hover:translate-y-1" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroDiagnostico;
